<template>
  <div>
    <v-form ref="form" v-model="areFormRulesRespected">
      <v-card class="px-8 pt-3 pb-3">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="mt-4">{{ $t('a') }}</h2>
            <small>{{ $t('a2') }}</small>
          </v-flex>
          <v-flex xs2 class="text-right" v-if="!isEditEnabled">
            <v-btn outlined class="mt-5" small @click="isEditEnabled=true">
              <v-icon small class="mr-1">mdi-pen</v-icon>
              {{ $t('b') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mt-8 wrap justify-space-between>
          <v-flex xs5>
            <v-text-field v-model="firstName" dense :label="$t('c')" background-color="white" prepend-inner-icon="person" outlined :rules="[firstNameRules]" :disabled="!isEditEnabled || isSavingPending"/>
          </v-flex>
          <v-flex xs5>
            <v-text-field v-model="lastName" dense :label="$t('d')" prepend-inner-icon="person_outline" outlined :rules="[lastNameRules]" :disabled="!isEditEnabled || isSavingPending"/>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between>
          <v-flex xs5>
            <v-text-field v-model="phoneNumber" dense :label="$t('f')" prepend-inner-icon="phone" outlined :rules="[phoneNumberRules]" :disabled="!isEditEnabled || isSavingPending"/>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-2 mb-6 justify-center v-if="isEditEnabled">
          <v-flex xs4 v-if="isSavingPending">
            <v-progress-linear indeterminate color="primary"></v-progress-linear>  
          </v-flex>
          <v-flex xs12 text-center v-else>
            <v-btn @click="save" :disabled="!areFormRulesRespected || isSavingPending" class="secondary mr-4">{{ $t('g') }}</v-btn>
            <v-btn @click="cancel" :disabled="isSavingPending" outlined class="ml-4">{{ $t('h') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    areFormRulesRespected: false,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    isEditEnabled: false,
    isSavingPending: false
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  async mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.firstName = this.user.data.firstName
      this.lastName = this.user.data.lastName
      this.phoneNumber = this.user.data.phoneNumber
    },
    save() {
      this.isSavingPending = true
      this.$functions.httpsCallable('updateUser')({
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber
      }).then(async () => {
        this.isSavingPending = false
        this.isEditEnabled = false
      })
    },
    cancel() {
      this.initData()
      this.isEditEnabled = false
    },
    firstNameRules(v) {
      if (!v) return this.$t('i')
      return true 
    },
    lastNameRules(v) {
      if (!v) return this.$t('j')
      return true
    },
    phoneNumberRules(v) {
      if (!v) return this.$t('l')
      return true
    },
  },
}
</script>



<i18n>
{
  "fr": {
    "a": "Vos coordonnées",
    "a2": "Votre nom, email et numéro de téléphone peuvent apparaître dans vos dossiers de compétences.",
    "b": "Éditer",
    "c": "Prénom",
    "d": "Nom de famille",
    "e": "Nom de votre entreprise",
    "f": "Numéro de téléphone",
    "g": "Sauvegarder",
    "h": "Annuler",
    "i": "Votre prénom est requis.",
    "j": "Votre nom de famille est requis.",
    "k": "Le nom de votre entreprise est requis.",
    "l": "Votre numéro de téléphone est requis."
  },
  "en": {
    "a": "Contact details",
    "a2": "Your name, email address and phone number may appear in your transformed CVs.",
    "b": "Edit",
    "c": "First name",
    "d": "Last name",
    "e": "Company name",
    "f": "Phone number",
    "g": "Update",
    "h": "Cancel",
    "i": "Your first name is required.",
    "j": "Your last name is required.",
    "k": "The name of your company is required.",
    "l": "Your phone number is required."
  }
}
</i18n>